// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g0bpA","colMin":"styles_colMin__2KWBU"};